import GuidelineBlock from "./GuidelineBlock";
import "./CriteriaUnit.css";
import { Dropdown, DropdownButton, InputGroup } from "react-bootstrap";
import { toastr } from "react-redux-toastr";

import label from "../labels/criteria_en.json";
function convertGuildeline(guideline) {
  let type;
  switch (guideline.type) {
    case "Angle":
      type = "None";
      break;
    case "T":
      type = "Straight";
      break;
    default:
      type = guideline.type;
  }
  return {
    ...guideline,
    type,
  };
}

export default function CriteriaUnit(props) {
  const criteriaUnit = props.criteriaUnit;
  const guidelines = props.guidelines;

  switch (criteriaUnit.type) {
    case "Field":
    case "AggregateSum":
      return (
        <CriteriaUnitField
          type={criteriaUnit.type}
          criteriaUnit={criteriaUnit}
          guidelines={guidelines}
          notifyChange={props.notifyChange}
          onDelete={props.onDelete}
          index={props.index}
        />
      );
    case "And":
    case "Or":
    case "AndSingle":
      if (!criteriaUnit.children) {
        criteriaUnit.children = [];
      }
      return (
        <CriteriaUnitComb
          type={criteriaUnit.type}
          childrenCriteria={criteriaUnit.children}
          criteriaUnit={criteriaUnit}
          guidelines={guidelines}
          notifyChange={props.notifyChange}
          onDelete={props.onDelete}
          index={props.index}
        />
      );
    case "Not":
      return (
        <CriteriaUnitNot
          type={criteriaUnit.type}
          child={criteriaUnit.child}
          criteriaUnit={criteriaUnit}
          guidelines={guidelines}
          notifyChange={props.notifyChange}
          onDelete={props.onDelete}
          index={props.index}
        />
      );
    default:
      return (
        <CriteriaUnitUnknown
          guidelines={guidelines}
          notifyChange={props.notifyChange}
          onDelete={props.onDelete}
          index={props.index}
        />
      );
  }
}

export function CriteriaUnitComb(props) {
  const children = props.childrenCriteria;
  const guidelines = props.guidelines;

  const onDelete = (index) => {
    toastr.confirm(label.Are_you_sure_you_want_criteria_node, {
      onOk: () => {
        children.splice(index, 1);
        props.notifyChange();
      },
    });
  };

  return (
    <>
      {props.criteriaUnit ? (
        <div className="criteriaUnitOuter">
          {guidelines.map((guideline, index) => (
            <GuidelineBlock key={index} type={guideline.type} />
          ))}
          <div className="criteriaUnitInner">
            <span>{props.type}</span>
            <input
              type="text"
              className="form-control inputText form-control-sm"
              placeholder="Description"
              value={props.criteriaUnit.description ?? ""}
              onChange={(event) => {
                props.criteriaUnit.description =
                  event.target.value || undefined;
                props.notifyChange();
              }}
            />
            <div className="afterInputDiv"></div>
            <button
              className="btn btn-sm btn-secondary"
              onClick={() => props.onDelete(props.index)}
            >
              -
            </button>
          </div>
        </div>
      ) : (
        <div className="criteriaUnitInner">Criteria</div>
      )}
      {children.map((criteriaUnit, index) => (
        <CriteriaUnit
          key={index}
          criteriaUnit={criteriaUnit}
          guidelines={[...guidelines.map(convertGuildeline), { type: "T" }]}
          notifyChange={props.notifyChange}
          onDelete={onDelete}
          index={index}
        />
      ))}
      <AddButton
        guidelines={[...guidelines.map(convertGuildeline), { type: "Angle" }]}
        criteriaUnits={children}
        onChange={props.notifyChange}
      />
    </>
  );
}

export function CriteriaUnitNot(props) {
  const guidelines = props.guidelines;

  const onDelete = () => {
    toastr.confirm(label.Are_you_sure_you_want_criteria_node, {
      onOk: () => {
        props.criteriaUnit.child = null;
        props.notifyChange();
      },
    });
  };

  return (
    <>
      <div className="criteriaUnitOuter">
        {guidelines.map((guideline, index) => (
          <GuidelineBlock key={index} type={guideline.type} />
        ))}
        <div className="criteriaUnitInner">
          <span>{props.type}</span>
          <input
            type="text"
            className="form-control inputText form-control-sm"
            placeholder="Description"
            value={props.criteriaUnit.description ?? ""}
            onChange={(event) => {
              props.criteriaUnit.description = event.target.value || undefined;
              props.notifyChange();
            }}
          />
          <div className="afterInputDiv"></div>
          <button
            className="btn btn-sm btn-secondary"
            onClick={() => props.onDelete(props.index)}
          >
            -
          </button>
        </div>
      </div>
      {props.child ? (
        <CriteriaUnit
          criteriaUnit={props.child}
          guidelines={[...guidelines.map(convertGuildeline), { type: "Angle" }]}
          notifyChange={props.notifyChange}
          onDelete={onDelete}
        />
      ) : (
        <AddButton
          guidelines={[...guidelines.map(convertGuildeline), { type: "Angle" }]}
          criteriaUnit={props.criteriaUnit}
          onChange={props.notifyChange}
        />
      )}
    </>
  );
}

const ERR_STR = "__err__";
function jsonStringify(value) {
  if (typeof value === "string" && value.startsWith(ERR_STR)) {
    return value.substring(ERR_STR.length);
  }
  return JSON.stringify(value);
}

function jsonParse(value) {
  try {
    return JSON.parse(value);
  } catch (error) {
    return ERR_STR + value;
  }
}

function getComparisonValueKey(comparison) {
  switch (comparison) {
    case "Equals":
    case "NotEquals":
    case "Contains":
    case "MinAgeAsOf":
    case "MaxAgeAsOf":
    case "FieldMinAgeAsOf":
    case "FieldMaxAgeAsOf":
      return "value";
    case "In":
    case "NotIn":
      return "values";
    case "Between":
    case "GreaterThan":
    case "GreaterThanEqualTo":
      return "minValue";
    case "LessThan":
    case "LessThanEqualTo":
      return "maxValue";
    default:
      return "value";
  }
}

function CriteriaUnitField(props) {
  const criteriaUnit = props.criteriaUnit;
  const guidelines = props.guidelines;

  // For AggregateSum
  const onDelete = () => {
    props.criteriaUnit.child = null;
    props.notifyChange();
  };

  return (
    <>
      <div className="criteriaUnitOuter">
        {guidelines.map((guideline, index) => (
          <GuidelineBlock key={index} type={guideline.type} />
        ))}
        <div className="row flexRow p-1">
          <div className="col-3 flexCenter padding-right-sm">
            {props.type === "AggregateSum" && "∑"}
            <input
              type="text"
              list="field-names"
              className="form-control form-control-sm"
              name="fieldName"
              value={criteriaUnit.fieldName}
              onChange={(event) => {
                criteriaUnit.fieldName = event.target.value;
                props.notifyChange(event.target.value);
              }}
            />
          </div>
          <div className="col-3 padding-x-sm">
            <select
              name="comparison"
              className="form-control form-control-sm"
              value={criteriaUnit.comparison}
              onChange={(event) => {
                criteriaUnit.comparison = event.target.value;
                const valueKeys = [
                  getComparisonValueKey(criteriaUnit.comparison),
                ];
                if (criteriaUnit.comparison === "Between") {
                  valueKeys.push("maxValue");
                }
                ["value", "values", "minValue", "maxValue"].forEach(
                  (valueKey) => {
                    if (!valueKeys.includes(valueKey)) {
                      if (criteriaUnit.hasOwnProperty(valueKey)) {
                        delete criteriaUnit[valueKey];
                      }
                    } else {
                      if (!criteriaUnit.hasOwnProperty(valueKey)) {
                        criteriaUnit[valueKey] = "";
                      }
                      if (
                        valueKey === "values" &&
                        !Array.isArray(criteriaUnit.values)
                      ) {
                        criteriaUnit.values = [];
                      }
                    }
                  }
                );
                props.notifyChange();
              }}
            >
              <option>{label.__Select__}</option>
              <option>{label.Equals}</option>
              <option>{label.NotEquals}</option>
              <option>{label.In}</option>
              <option>{label.NotIn}</option>
              <option>{label.Contains}</option>
              <option>{label.Between}</option>
              <option>{label.GreaterThan}</option>
              <option>{label.LessThan}</option>
              <option>{label.GreaterThanEqualTo}</option>
              <option>{label.LessThanEqualTo}</option>
              <option>{label.MinAgeAsOf}</option>
              <option>{label.MaxAgeAsOf}</option>
              <option>{label.FieldMinAgeAsOf}</option>
              <option>{label.FieldMaxAgeAsOf}</option>
            </select>
          </div>
          <div className="col-3 padding-x-sm">
            <input
              type="text"
              className="form-control form-control-sm"
              placeholder={getComparisonValueKey(criteriaUnit.comparison)}
              value={
                jsonStringify(
                  criteriaUnit[getComparisonValueKey(criteriaUnit.comparison)]
                ) ?? ""
              }
              onChange={(event) => {
                criteriaUnit[getComparisonValueKey(criteriaUnit.comparison)] =
                  jsonParse(event.target.value);
                props.notifyChange();
              }}
            />
          </div>
          <div className="col-3 flexGapFive padding-left-sm">
            {criteriaUnit.comparison === "Between" ? (
              <input
                type="text"
                className="form-control form-control-sm"
                placeholder="maxValue"
                value={jsonStringify(criteriaUnit.maxValue) ?? ""}
                onChange={(event) => {
                  criteriaUnit.maxValue = jsonParse(event.target.value);
                  props.notifyChange();
                }}
              />
            ) : (
              <div className="flexOne"></div>
            )}
            <button
              className="btn btn-sm btn-secondary"
              onClick={() => props.onDelete(props.index)}
            >
              -
            </button>
          </div>
        </div>
      </div>
      {props.type === "AggregateSum" &&
        (props.criteriaUnit.child ? (
          <CriteriaUnit
            criteriaUnit={props.criteriaUnit.child}
            guidelines={[
              ...guidelines.map(convertGuildeline),
              { type: "Angle" },
            ]}
            notifyChange={props.notifyChange}
            onDelete={onDelete}
          />
        ) : (
          <AddButton
            guidelines={[
              ...guidelines.map(convertGuildeline),
              { type: "Angle" },
            ]}
            criteriaUnit={props.criteriaUnit}
            onChange={props.notifyChange}
          />
        ))}
    </>
  );
}

function AddButton(props) {
  const guidelines = props.guidelines;

  const addOrSet = (criteriaUnit) => {
    if (props.criteriaUnits) {
      props.criteriaUnits.push(criteriaUnit);
    } else if (props.criteriaUnit) {
      props.criteriaUnit.child = criteriaUnit;
    }
  };

  const addField = (event) => {
    event.preventDefault();
    addOrSet({
      type: "Field",
      fieldName: "",
      comparison: "Equals",
      value: "",
    });
    props.onChange && props.onChange();
  };

  const addAnd = (event) => {
    event.preventDefault();
    addOrSet({
      type: "And",
      children: [],
    });
    props.onChange && props.onChange();
  };

  const addOr = (event) => {
    event.preventDefault();
    addOrSet({
      type: "Or",
      children: [],
    });
    props.onChange && props.onChange();
  };

  const addNot = (event) => {
    event.preventDefault();
    addOrSet({
      type: "Not",
      child: null,
    });
    props.onChange && props.onChange();
  };

  const addAndSingle = (event) => {
    event.preventDefault();
    addOrSet({
      type: "AndSingle",
      children: [],
    });
    props.onChange && props.onChange();
  };

  const addAggregateSum = (event) => {
    event.preventDefault();
    addOrSet({
      type: "AggregateSum",
      fieldName: "",
      comparison: "Equals",
      value: "",
      child: null,
    });
    props.onChange && props.onChange();
  };

  return (
    <div className="displayFlex">
      {guidelines.map((guideline, index) => (
        <GuidelineBlock key={index} type={guideline.type} />
      ))}
      <div className="flexOne">
        <InputGroup>
          <DropdownButton
            size="sm"
            variant="secondary"
            title="+"
            className="criteria-add"
          >
            <Dropdown.Item onClick={addField}>{label.Field}</Dropdown.Item>
            <Dropdown.Item onClick={addAnd}>{label.And}</Dropdown.Item>
            <Dropdown.Item onClick={addAndSingle}>
              {label.And_Single}
            </Dropdown.Item>
            <Dropdown.Item onClick={addOr}>{label.Or}</Dropdown.Item>
            <Dropdown.Item onClick={addNot}>{label.Not}</Dropdown.Item>
            <Dropdown.Item onClick={addAggregateSum}>
              {label.AggregateSum}
            </Dropdown.Item>
          </DropdownButton>
        </InputGroup>
      </div>
    </div>
  );
}

function CriteriaUnitUnknown(props) {
  return (
    <div className="displayFlex">
      {props.guidelines.map((guideline, index) => (
        <GuidelineBlock key={index} type={guideline.type} />
      ))}
      <div className="row flexOne p-1">
        <div className="col-3 flexCenter padding-right-sm">Unknown</div>
        <div className="col-9 flexGapFive padding-left-sm">
          <div className="flexOne"></div>
          <button
            className="btn btn-sm btn-secondary"
            onClick={() => props.onDelete(props.index)}
          >
            -
          </button>
        </div>
      </div>
    </div>
  );
}
